// frontend/src/api/folders.js
import client from "./client";

/**
 * Folder API — wrappers around the /api/folders endpoints (P14-G2).
 */

/**
 * Window event broadcast when folders or their code counts change (folder
 * created/renamed/deleted, code moved, bulk action). The sidebar FolderTree
 * listens for it and refetches so its counts stay live across the app.
 */
export const FOLDERS_CHANGED_EVENT = "qrflow:folders-changed";

/** Notify the sidebar that the folder tree / counts need refreshing. */
export function notifyFoldersChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FOLDERS_CHANGED_EVENT));
  }
}

/**
 * Fetch the org's folder tree (nested, with per-folder code counts).
 * @returns {Promise<Array<{id, name, parent_folder_id, code_count, children}>>}
 */
export async function getFolderTree() {
  const response = await client.get("/api/folders");
  return response.data;
}

/**
 * Create a folder (admin+).
 * @param {{ name: string, parent_folder_id?: string|null }} payload
 * @returns {Promise<object>}
 */
export async function createFolder(payload) {
  const response = await client.post("/api/folders", payload);
  return response.data;
}

/**
 * Rename a folder (admin+).
 * @param {string} folderId
 * @param {string} name
 * @returns {Promise<object>}
 */
export async function renameFolder(folderId, name) {
  const response = await client.patch(`/api/folders/${folderId}`, { name });
  return response.data;
}

/**
 * Delete a folder; its children and codes re-parent to its parent (admin+).
 * @param {string} folderId
 * @returns {Promise<void>}
 */
export async function deleteFolder(folderId) {
  await client.delete(`/api/folders/${folderId}`);
}

/**
 * Move a code into a folder (or to the root when folderId is null). Member+.
 * @param {number} codeId
 * @param {string|null} folderId
 * @returns {Promise<object>} The updated QRCodeRead
 */
export async function moveCodeToFolder(codeId, folderId) {
  const response = await client.post(`/api/codes/${codeId}/move`, {
    folder_id: folderId,
  });
  return response.data;
}
